<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="preview ? '详情' : model.pkid ? '编辑' : '新建销售采购订单'"
      width="1400px"
      class="adaptationModal"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        class="form"
        label-width="75px">
      <div v-if="model.pkid" class="editTitle">采购信息</div>
      <el-row v-if="model.pkid">
        <el-col :span="12">
          <el-form-item label="采购单号">
            <el-input v-model="model.purchaseOrderNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商">
            <el-input v-model="model.supplierName" placeholder="请选择供应商" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">采购订单明细</div>
      <el-button :disabled="disabled" type="primary" style="margin-bottom: 8px" @click="$refs.salesOrderSelect.open()"> 添加 </el-button>
      <Table
          v-loading="tableLoading"
          height="550"
          class="purchaseTable"
          border
          stripe
          :columns="columns"
          :data="model.detailVOS">
        <template slot="deliveryDate" slot-scope="{ row, index }">
          <el-date-picker
              v-model="row.deliveryDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="date"
              :disabled="disabled"
              @input="inputHandle(row, index)"
          />
        </template>
        <template slot="qty" slot-scope="{ row, index }">
          <el-input v-model="row.qty" @input="inputHandle(row, index)"/>
        </template>
        <template slot="finalDeliveryDate" slot-scope="{ row, index }">
          <el-date-picker
              v-model="row.finalDeliveryDate"
              :disabled="row.qty === row.sendedQuantity"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择"
              @input="inputHandle(row, index)"
          />
        </template>
        <template slot="unitPrice" slot-scope="{ row, index }">
          <el-input
              v-if="preview"
              v-model="row.unitPrice"
              placeholder="***"
              disabled
              @input="inputHandle(row, index)"/>
          <el-input v-else v-model="row.unitPrice" :disabled="disabled" @input="inputHandle(row, index)"/>
        </template>
        <template slot="action" slot-scope="{ index }">
          <el-button :disabled="disabled" type="danger" @click="model.detailVOS.splice(index, 1)">删除</el-button>
        </template>
      </Table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" :disabled="disabled" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <sales-order-select ref="salesOrderSelect" @select="salesOrderSelect"/>
  </el-dialog>
</template>

<script>
  import SalesOrderSelect from "@/views/SalesManage/SalesOrder/SalesOrderSelect";
  export default {
    components: {
      SalesOrderSelect,
    },

    data() {
      return {
        disabled: false,
        contentLoading: false,
        dialogVisible: false,
        tableLoading: false,
        submitLoading: false,
        preview: "",
        model: {
          pkid: 0,
          purchaseOrderNo: "",
          supplierName: "",
          detailVOS: [],
        },
        columns: [
          {
            title: "销售单号",
            key: "salesOrderNo",
            width: 130,
            align: "center",
          },
          {
            title: "供应商编号",
            key: "supplierNo",
            align: "center",
            width: 110,
          },
          {
            title: "供应商名称",
            key: "supplierName",
            minWidth: 260,
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 160,
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 360,
          },
          {
            title: "要求交期",
            key: "deliveryDate",
            width: 160,
            align: "center",
            slot: "deliveryDate",
          },
          {
            title: "数量",
            key: "qty",
            width: 100,
            slot: "qty",
            align: "center",
          },
          {
            title: "送货单数量",
            width: 105,
            key: "sendedQuantity",
            align: "center",
          },
          {
            title: "最终交期",
            key: "finalDeliveryDate",
            width: 160,
            align: "center",
            slot: "finalDeliveryDate",
          },
          {
            title: "单价",
            key: "unitPrice",
            width: 100,
            slot: "unitPrice",
            align: "center",
          },
          {
            title: "总价",
            width: 80,
            align: "center",
            render: (h, params) => {
              if (this.preview) {
                if (params.row.unitPrice == null || params.row.qty == null) {
                  return h("span", "***");
                } else {
                  return h("span", params.row.unitPrice * params.row.qty);
                }
              } else {
                return h("span", params.row.unitPrice * params.row.qty >= 0 ? params.row.unitPrice * params.row.qty : "");
              }
            },
          },
          {
            title: "操作",
            align: "center",
            width: 80,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      open(row, mark, preview) {
        this.dialogVisible = true;
        this.disabled = mark;
        this.preview = preview;
        if (row) {
          this.getData(row.pkid);
        }
      },

      getData(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `purchaseOrders/${pkid}`)
          .then((res) => {
            if (res.success) {
              this.model = Object.assign(this.model, res.data);
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 选择销售订单
      salesOrderSelect(row) {
        const arr = this.model.detailVOS.filter((item) => item.salesOrderNo === row.salesOrderNo);
        if (arr.length) {
          this.$confirm("该销售单号已存在，请勿重复添加！", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        // 根据销售订单id查询采购明细
        this.tableLoading = true;
        this.$http
          .get("basic", `purchaseOrderDetails/cvPD/${row.salesOrderId}`)
          .then((res) => {
            if (res.success) {
              if (res.data && res.data.length) {
                this.model.detailVOS = [...this.model.detailVOS, ...res.data];
              }
            }
            this.tableLoading = false;
          })
          .catch(() => {
            this.tableLoading = false;
          });
      },

      // 输入数据 动态更新detailVOs
      inputHandle(row, index) {
        this.$set(this.model.detailVOS, index, row);
      },

      // 确定
      submitHandle() {
        this.submitLoading = true;
        this.$http
          .save("basic", "purchaseOrders/saveCvPD", this.model.detailVOS)
          .then((resp) => {
            this.submitLoading = false;
            if (resp.success) {
              if (this.model.pkid) {
                this.$emit("save-success");
                this.$message.success("编辑成功");
              } else {
                this.$emit("save-success");
                this.$message.success("添加成功");
              }
              this.dialogVisible = false;
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>
